@if (isShown) {
  <div id="loading-container">
    <div class="centered">
      <div id="spinner" class="loader">
        <div class="circle dark"></div>
        <div class="circle light"></div>
      </div>
      <p>{{spinnerMessageKey | translate}}</p>
    </div>
  </div>
}
